import React from 'react'
import PropTypes from 'prop-types'
import Collapsible from 'react-collapsible'

import EmbedsList from './EmbedsList'

function DetailsStepEmbeds({
  itemId, embeds, onChange, onDragStateChange,
}) {
  return (
    <Collapsible
      className="Collapsible--transparent"
      openedClassName="Collapsible--transparent is-opened"
      overflowWhenOpen="visible"
      trigger={<div className="modal-section__title modal-section__title--not-spaced">Embeds</div>}
      transitionTime={300}
      open={embeds.length > 0}
    >
      {embeds.length > 0 ? (
        <EmbedsList
          key={embeds}
          itemId={itemId}
          embeds={embeds}
          onChange={onChange}
          onDragStateChange={onDragStateChange}
        />
      ) : (
        <div><i>Your collection models have no embeds.</i></div>
      )}
    </Collapsible>
  )
}

DetailsStepEmbeds.propTypes = {
  itemId: PropTypes.number.isRequired,
  embeds: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onDragStateChange: PropTypes.func.isRequired,
}

export default DetailsStepEmbeds
